import React, { useState, useMemo } from "react";
import { Chart } from "react-google-charts";
import { ChartWrapperOptions } from "react-google-charts/dist/types";

import { ViewOfTheRoom } from "../../api";
import { divergingScheme4 as colorArray, getColor } from "../../common/helpers/colors";

import Loader from "../../common/components/Loader";

interface ValueInTheRoomPieChartProps {
  view: ViewOfTheRoom;
}

const ValueInTheRoomPieChart = ({ view }: ValueInTheRoomPieChartProps) => {

  const [isReady, setIsReady] = useState(false);

  const colors = (totalValues => {
    const arr: string[] = [];
    for (let i = 0; i < totalValues; i++) {
      arr.push(getColor(colorArray, i, totalValues));
    }
    return arr;
  })(view.data.length);

  const options: ChartWrapperOptions["options"] = {
    fontName: "Helvetica",
    pieHole: 0.8,
    is3D: false,
    slices: colors.map((color) => ({ color })),
    pieSliceText: "none",
    legend: "none",
    chartArea: {
      width: "100%",
      height: "85%",
    },
    backgroundColor: "transparent",
    //backgroundColor: { fill: 'transparent' }
  };

  const data = useMemo(() => {
    const arr: any[] = [["Name", ...(view.labels ?? ["Value"])]];
    arr.push(...view.data.map(x => [x.name, ...x.values]));
    return arr;
  }, [view]);

  return (
    <>
      <div className="position-relative">
        {/* Total */}
        {isReady && typeof view.total === "number" && (
          <span className="c-vitr__total">
            &pound;{view.total}
            {!!view.suffix && (
              <span className="c-vitr__suffix">
                {view.suffix}
              </span>
            )}
          </span>
        )}
        <Chart
          height={200}
          chartType="PieChart"
          data={data}
          options={options}
          loader={
            <div style={{ width: "100%", height: 200 }}>
              <Loader show />
            </div>
          }
          chartEvents={[
            {
              eventName: "ready",
              callback: () => {
                setIsReady(true);
              },
            },
          ]}
        />
      </div>
      {/* Values list */}
      <div className="bg-panel-light">
        {view.data.map(
          (item, i) => (
            <div
              key={i}
              className="d-flex align-items-center justify-content-between border-top px-3 py-1"
            >
              <div className="d-flex align-items-center">
                <div
                  className="c-vitr__color-circle"
                  style={{
                    backgroundColor: colors[i],
                  }}
                ></div>
                <div className="mx-2">{item.name}</div>
              </div>
              <div className="text-nowrap">
                {item.formattedValues
                  ? <span>{item.formattedValues[0]}</span>
                  : (
                    <>
                      {!!view.prefix && (
                        <span>{view.prefix}</span>
                      )}
                      <span>{item.values[0]}</span>
                      {!!view.suffix && (
                        <span>{view.suffix}</span>
                      )}
                    </>
                  )}
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default ValueInTheRoomPieChart;
